import styled from "styled-components";

import { Link } from "react-router-dom";

export const RoleOrgChartIllustrationImage = styled.img.attrs({
  className: "h-full w-full object-cover",
})``;

export const RoleOrgChartSection = styled.div.attrs({
  className: "flex items-start justify-between gap-2",
})``;

export const RoleOrgChartSectionSecondary = styled.div.attrs({
  className: "org-node-card-body mt-3 flex flex-1 flex-col items-center gap-0.5",
})``;

export const RoleOrgChartPanelCard = styled.div.attrs({
  className:
    "h-20 w-20 overflow-hidden rounded-[18px] border border-[var(--brand-border)] bg-[var(--brand-bg)] shadow-[0_3px_8px_rgba(15,23,42,0.04)]",
})``;

export const RoleOrgChartBodyText = styled.p.attrs({
  className:
    "mt-3 w-full px-1 text-[13px] font-semibold leading-[1.15rem] text-[var(--brand-ink)] [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] overflow-hidden",
})``;

export const RoleOrgChartEyebrowText = styled.p.attrs({
  className:
    "mt-1.5 w-full truncate px-1 text-xs font-medium uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;

export const RoleOrgChartBodyTextSecondary = styled.p.attrs({
  className:
    "mt-1.5 w-full px-1 text-xs leading-[1rem] text-[var(--brand-muted)] [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] overflow-hidden",
})``;

export const RoleOrgChartInlineText = styled.span.attrs({
  className:
    "mt-auto inline-flex items-center rounded-full bg-[rgba(240,191,86,0.1)] px-2.5 py-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-[var(--brand-highlight)]",
})``;

export const RoleOrgChartActionLink = styled(Link).attrs({ className: "block" })``;

export const RoleOrgChartSectionTertiary = styled.div.attrs({ className: "org-mobile-children" })``;

export const RoleOrgChartContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const RoleOrgChartHeaderRow = styled.div.attrs({
  className: "flex flex-wrap items-center justify-between gap-3",
})``;

export const RoleOrgChartSectionQuaternary = styled.div.attrs({
  className: "flex flex-wrap gap-2",
})``;

export const RoleOrgChartStatusBadge = styled.span.attrs({
  className:
    "inline-flex items-center rounded-full border border-[var(--brand-border)] bg-[var(--brand-bg)] px-3 py-1.5 text-xs font-medium text-[var(--brand-ink)]",
})``;

export const RoleOrgChartSecondaryButton = styled.button.attrs({
  className:
    "brand-button-secondary !rounded-full !px-3.5 !py-2 text-xs font-semibold uppercase tracking-[0.14em]",
})``;

export const RoleOrgChartScrollArea = styled.div.attrs({
  className: "org-tree-desktop overflow-x-auto pb-2",
})``;

export const RoleOrgChartSectionBody = styled.div.attrs({
  className: "org-tree-frame px-4 sm:px-6",
})``;

export const RoleOrgChartSectionQuinary = styled.div.attrs({ className: "org-tree-canvas" })``;

export const RoleOrgChartSectionSenary = styled.div.attrs({ className: "org-tree-mobile" })``;

export const RoleOrgChartHeaderRowSecondary = styled.div.attrs({
  className: "brand-panel-muted flex items-center justify-between gap-3 px-4 py-3",
})``;

export const RoleOrgChartMetaText = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const RoleOrgChartBodyTextTertiary = styled.p.attrs({
  className: "text-sm leading-6 text-[var(--brand-muted)]",
})``;
